module.exports = __webpack_public_path__ + "img/code.5bdc48b2.gif";